import { clone } from "lodash";
import { IUserGrantedPermissions, IUserProfile, IUserStore } from "../../types/user";
import { StorageService } from "./storageService.service";

export class UserProfile implements IUserProfile {

    private _email: string;
    private _emailVerified: boolean;
    private _firstName: string;
    private _fullName: string;
    private _grantedPermissions: IUserGrantedPermissions;
    private _grantedTenants: string[];
    private _lastName: string;
    private _nickName: string;
    private _organizationAdministrator: boolean;
    private _organizationCode: string;
    private _picture: string;
    private _platformManagedOrganizations: string[];
    private _platformRoot: boolean;
    private _platformUser: boolean;
    private _productionWarning: boolean;
    private _tenantCode: string;
    private _tenantId: string;
    private _updatedAt: string;
    private _userId: string;

    constructor(
        user: IUserStore, 
        private _storage?: StorageService
    ) {
        this._email = user.email;
        this._emailVerified = user.emailVerified;
        this._firstName = user.firstName;
        this._fullName = user.fullName;
        this._grantedPermissions = user.grantedPermissions;
        this._grantedTenants = user.grantedTenants;
        this._lastName = user.lastName;
        this._nickName = user.nickName;
        this._organizationAdministrator = user.organizationAdministrator;
        this._organizationCode = user.organizationCode;
        this._picture = user.picture;
        this._platformManagedOrganizations = user.platformManagedOrganizations;
        this._platformRoot = user.platformRoot;
        this._platformUser = user.platformUser;
        this._productionWarning = user.productionWarning;
        this._tenantCode = user.tenantCode;
        this._tenantId = user.tenantId;
        this._updatedAt = user.updatedAt;
        this._userId = user.userId;
    }
    
    public get email(): string { return this._email; };
    public get emailVerified (): boolean { return this._emailVerified; }
    public get firstName(): string { return this._firstName; }
    public get grantedPermissions(): IUserGrantedPermissions { return this._grantedPermissions; };
    public get grantedTenants(): string[] { return this._grantedTenants };
    public get lastName(): string { return this._lastName; }
    public get userId(): string { return this._userId; }
    public get updatedAt(): string { return this._updatedAt; }
    public get tenantCode(): string { return this._tenantCode; }
    public get role(): string { return this.platformUser ? "Root" : "Admin"; }
    public get productionWarning(): boolean { return this._productionWarning; }
    public set productionWarning(value: boolean) { this._productionWarning = value }
    public get platformUser(): boolean { return this._platformUser; }
    public get platformRoot(): boolean { return this._platformRoot; }
    public get platformManagedOrganizations(): string[] { return clone(this._platformManagedOrganizations); }
    public get picture(): string { return this._picture; }
    public get organizationCode(): string { return this._organizationCode; }
    public get organizationAdministrator(): boolean { return this._organizationAdministrator; }
    public set organizationAdministrator(value: boolean) { this._organizationAdministrator = value; }
    public get openairApps(): string[] {
        const currentTenant = this._storage?.get.currentAirline();
        return currentTenant ? 
            this._grantedPermissions[currentTenant.code].apps : 
            []; 
    }
    public get nickName(): string { return this._nickName; }
    public get tenantId(): string { return this._tenantId; }
    
    public get fullName() : string { return this._fullName; }
    public get name(): string { return this.fullName; }
    public get airlineCode(): string { return this._tenantCode; }
    public get airlineId(): string { return this._tenantId; }
    public get openair_apps(): Array<{ name: string }> { return this.openairApps.map(app => ({ name: app })) };
    public get production_warning(): boolean { return this._productionWarning; }
    public set production_warning(value: boolean) { this._productionWarning = value }

    public toStorage(): IUserStore {
        return {
            email: this._email,
            emailVerified: this._emailVerified,
            firstName: this._firstName,
            fullName: this._fullName,
            grantedPermissions: this._grantedPermissions,
            grantedTenants: this._grantedTenants,
            lastName: this._lastName,
            nickName: this._nickName,
            organizationAdministrator: this._organizationAdministrator,
            organizationCode: this._organizationCode,
            picture: this._picture,
            platformManagedOrganizations: this._platformManagedOrganizations,
            platformRoot: this._platformRoot,
            platformUser: this._platformUser,
            productionWarning: this._productionWarning,
            tenantCode: this._tenantCode,
            tenantId: this._tenantId,
            updatedAt: this._updatedAt,
            userId: this._userId
        }
    }
}